let nodeEnv = process.env.NODE_ENV;//当前环境
//封面新闻接口地址
let HTTP_URL = nodeEnv === 'development' ? 'http://47.97.243.140:8081' : nodeEnv === 'test' ? 'http://47.97.243.140:8081' : 'https://api.thecover.cn';
//活动接口地址
let ACTIVITY_URL = nodeEnv === 'development' ? 'https://actapi.thepage.cn' : nodeEnv === 'test' ? 'http://170.240.110.234:7001' : 'https://actapi.thepage.cn';

export default {
    //安卓下载apk地址
    DOWNLOAD_ADDRESS: 'https://api.thecover.cn/download.js',
    //scheme地址
    APP_SCHEME_URL: 'cover://cn.thecover.www', 
    //微信里面scheme地址
    WEIXIN_APP_SCHEME_URL: 'http://0.0.0.0:22021', 
    //UniversalLink地址
    UNIVERSALLINK: 'https://wapcdn.thecover.cn/UniversalLinks/index.html',
    //封面新闻接口地址
    HTTP_URL,
    //活动接口地址 
    ACTIVITY_URL, 
    // 七牛图片服务器地址
    QINIUDOMAIN: 'https://yunyingcdn.thecover.cn/', 
    //微信应用宝地址
    WEXIN_APP_DOWNLOAD_ADDRESS: "http://a.app.qq.com/o/simple.jsp?pkgname=cn.thecover.www.covermedia", 
    ApiToken: sessionStorage.getItem('TOKEN'),
    Api_sign_root: '12345678',
    wx_appid: 'wx1294924fd43f1119',
    //当前时间戳
    timestamp: new Date().getTime(),
    // 请求接口地址
    apiurl: {
        'qiNiuToken': '/qiniu/tokenkey', //获取七牛token
        'aLiPayLogin': '/wap/aLiPayLogin', // 获取支付宝授权用户的登录
        'weixingetConf': '/weixin/getConf', // 获取微信配置信息
        'recordActivityClickRate': '/activity/recordActivityClickRate', // 记录活动点击量
        'setMessageInfo': '/activity/setMessageInfo', // 存储消息信息
    },
}